export function isKeyValueListEmpty(list: { [id: string]: any }): boolean {
  return !list || !Object.keys(list).some((key) => !!list[key]);
}
